var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpanishLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -41 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m407 0h-302c-57.898438 0-105 47.101562-105 105v168.945312c0 57.898438 47.101562 105 105 105h15.582031l36.519531 46.332032c2.847657 3.609375 7.1875 5.714844 11.78125 5.714844s8.9375-2.105469 11.78125-5.714844l36.519532-46.332032h189.816406c57.898438 0 105-47.101562 105-105v-168.945312c0-57.898438-47.101562-105-105-105zm0 0",
    fill: "#ff337a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 117.957031h512v143.074219h-512zm0 0",
    fill: "#ffe95c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m407 0h-151v378.945312h151c57.898438 0 105-47.101562 105-105v-168.945312c0-57.898438-47.101562-105-105-105zm0 0",
    fill: "#d1005b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 117.957031h256v143.074219h-256zm0 0",
    fill: "#fcc733"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishLanguage);
export default __webpack_public_path__ + "static/media/spanish-language.f3126e539a2bfd76d9fa9753216fae08.svg";
export { ForwardRef as ReactComponent };